"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toClientModel = exports.toCamelCase = void 0;
function toCamelCase(name) {
    return name.replace(/_([a-z])/g, function (all, symbol) { return symbol.toUpperCase(); });
}
exports.toCamelCase = toCamelCase;
function toClientModel(model) {
    if (!model) {
        return {};
    }
    return Object.keys(model)
        .filter(function (key) { return key[0] !== '_'; })
        .filter(function (key) { return typeof model[key] !== 'function'; })
        .reduce(function (acc, key) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[toCamelCase(key)] = model[key], _a)));
    }, {});
}
exports.toClientModel = toClientModel;
//# sourceMappingURL=toClientModel.js.map